import { autorun, computed, observable } from 'mobx';

export default class FolderModel {
  id;
  name;
  @observable stations = [];

  store;
  autoSave;
  saveHandler;

  constructor(store, folder) {
    this.store = store;
    this.id = folder.id;
    this.name = folder.name;
    this.description = folder.description;
    this.stations = folder.stations || [];
    // this.stations = (
    //   folder.stations &&
    //   folder.stations.map(station => (
    //     this.store.stationStore.resolveItem(station)
    //   ))
    // ) || [];

    // this.saveHandler = autorun(() => {
      // const json = this.asJson;

      // if (this.autoSave) {
        // this.store.transportLayer.saveFolder(json);
      // }
    // });
  }

  @computed get asJson() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      parent_id: this.parent_id,
      // stations: this.stations,
    };
  }

  updateFromJson(json) {
    // console.log('updateFromJson', json);

    this.autoSave = false;

    this.id = json.id;
    this.name = json.name;
    this.description = json.description;
    this.parent_id = json.parent_id;
    this.stations = json.stations;
    // this.stations = this.stations.map(station => (
      // this.store.stationStore.resolveItem(station.id)
    // ));

    this.autoSave = true;
  }

  // dispose() {
    // this.saveHandler();
  // }
}



// WEBPACK FOOTER //
// ./src/models/FolderModel.js